import React from 'react';

const PolygonIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="29" height="23" viewBox="0 0 29 23" fill="none">
            <path
                d="M16.1634 21.5082C15.3716 22.6943 13.6284 22.6943 12.8366 21.5082L0.554935 3.11043C-0.332272 1.7814 0.620396 0 2.21835 0H26.7817C28.3796 0 29.3323 1.7814 28.4451 3.11043L16.1634 21.5082Z"
                fill="#0B1024"
            />
        </svg>
    );
};

export default PolygonIcon;
